import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "32",
  height: "64",
  viewBox: "0 0 32 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16.856 17L21.856 12L16.856 7",
  stroke: "white",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M9.85596 17L14.856 12L9.85596 7",
  stroke: "white",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.73348 46.079V26.8549C7.73348 26.0977 8.03426 25.3716 8.56966 24.8362C9.10505 24.3008 9.8312 24 10.5884 24C11.3455 24 12.0717 24.3008 12.6071 24.8362C13.1425 25.3716 13.4432 26.0977 13.4432 26.8549V36.8273M13.4432 36.8273V41.2816M13.4432 36.8273C14.9862 34.6845 18.44 35.3975 19.1741 38.7305C19.1868 38.7855 19.1977 38.8411 19.2066 38.8973M19.2066 38.8973C19.2258 39.0468 19.2354 39.1982 19.2354 39.3515V41.274M19.2066 38.8973C20.1516 36.3098 24.9643 37.2835 24.9643 40.9922M24.9643 40.9922V43.1887M24.9643 40.9922C25.7387 38.1364 30.8217 40.1316 30.7105 43.4724V49.5635C30.7047 52.8717 30.1547 55.2714 28.1862 57.2436C26.3692 59.4133 26.7967 60.6265 26.7507 62.3458M7.73348 37.4061C5.20348 39.6946 2.33615 42.8207 1.97007 43.5605C0.264234 46.1538 0.871817 48.1855 3.29257 51.6412C5.09615 54.2095 7.51498 57.075 7.64148 57.2187C8.92948 58.6792 8.67648 59.8407 8.67648 62.3228",
  stroke: "white",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }